import moment from 'moment-timezone'
import * as yup from 'yup'

export const draftValidationSchema = yup.object().shape({
  clinicalHistoryDescription: yup
    .string()
    .max(5000, 'Máximo 5000 caracteres')
    .optional()
    .nullable(),
  clinicalHistoryAspects: yup
    .string()
    .max(5000, 'Máximo 5000 caracteres')
    .optional()
    .nullable(),
  clinicalHistoryLatexAllergy: yup.string().optional().nullable(),
  clinicalHistoryOtherAllergy: yup
    .string()
    .max(500, 'Máximo 500 caracteres')
    .optional()
    .nullable(),
  clinicalHistoryOncology: yup.boolean().nullable(),
  clinicalHistoryBloodTransfusion: yup.boolean().nullable(),
  clinicalHistoryTechnique: yup.string().optional().nullable(),
  clinicalHistoryCongelation: yup.boolean().nullable(),
  clinicalHistoryBloodReserve: yup.boolean().nullable(),
  clinicalHistoryHospitalized: yup.boolean().nullable(),
  clinicalHistoryExpectedDate: yup
    .date()
    .typeError('Data inválida')
    .nullable()
    .optional()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .test(
      'greater_then_today',
      'A data informada não pode ser menor que a atual.',
      (value) => {
        if (value) {
          const date = moment(value).startOf('day')
          const now = moment().startOf('day')
          return date.isValid() && date >= now
        }
        return true
      }
    )
    .test(
      'less_then_one_year',
      'A data informada não pode ser maior que 1 ano a partir da data atual.',
      (value) => {
        if (value) {
          const date = moment(value).startOf('day')
          const oneYearFromNow = moment().add(1, 'year').startOf('day')
          return date.isValid() && date <= oneYearFromNow
        }
        return true
      }
    ),
  clinicalHistoryBullishForecastDate: yup
    .date()
    .typeError('Data inválida')
    .nullable()
    .optional()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .test(
      'greater_then_today',
      'A data informada não pode ser menor que a atual.',
      (value) => {
        if (value) {
          const date = moment(value).startOf('day')
          const now = moment().startOf('day')
          return date.isValid() && date >= now
        }
        return true
      }
    ),
  clinicalHistoryHospitalizationType: yup.string().optional().nullable(),
  clinicalHistoryHospitalizationMode: yup.string().optional().nullable(),
  clinicalHistoryHospitalizationDailyQuantity: yup
    .number()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .nullable()
    .when('clinicalHistoryHospitalizationMode', {
      is: 'ambulatory',
      then: (schema) => schema.min(0, 'Mínimo 0 dias'),
      otherwise: (schema) => schema.min(1, 'Mínimo 1 dia')
    }),
  clinicalHistoryCti: yup.boolean().nullable(),
  clinicalHistoryMedicalObservations: yup
    .string()
    .max(5000, 'Máximo 5000 caracteres')
    .optional()
    .nullable()
})
